var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-icon',_vm._b({attrs:{"size":"15"},on:{"click":_vm.handleHiddenClick}},'v-icon',_vm.$attrs,false),[_vm._v(" "+_vm._s(_vm.hidden ? "$vuetify.icons.iconEyeOff" : "$vuetify.icons.iconEye")+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }